/**
 * 获取浏览器的主语言
 * @returns {string} 浏览器的主语言代码（例如: 'zh-CN', 'en-US', 'ja' 等）
 */
export function getBrowserLanguage(): string {
  // 优先使用 navigator.language（现代浏览器）
  let language = 'en';
  if (navigator.language) {
    language = navigator.language;
  }

  // 兼容旧版 IE 浏览器
  if ((navigator as any).userLanguage) {
    language = (navigator as any).userLanguage;
  }

  // 最后的备选方案
  if ((navigator as any).browserLanguage) {
    language = (navigator as any).browserLanguage;
  }
  return language.split('-')[0].toLowerCase();
}
